module.exports = __webpack_public_path__ + "static/img/216_TO8_2163.0e7da35.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/216_TO8_2163.jpg
// module id = +p9f
// module chunks = 0